
export default {
  bind(el, binding) {
    el.addEventListener('keyup', (e) => {
      if (e.key === '.') {
        e.preventDefault();
        const event = new CustomEvent('input', { bubbles: true });
        // eslint-disable-next-line no-param-reassign
        el.value = el.value.replace('.', ',');
        el.dispatchEvent(event);
      }
    });
  },
};
